import {showNaToast} from './native';
import {isHarmonyOS} from './tools';

export function harmonyInterceptor(): any {
    if (!isHarmonyOS) {
        return null;
    }

    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        descriptor.value = function () {
            showNaToast('该功能暂不支持');
            return null;
        };

        return descriptor;
    };
}
